import notify from './notify';
import imageService from './image-service';
import translateModel from './translateModel';
import photoswipe from './photoswipe';
import loggerService from '../utils/loggerService';
import { convertProductCurrency } from '../utils/currency';

window.shopline = Object.assign(window.shopline || {}, {
  notify,
  translateModel,
  imageService,
  photoswipe,
  loggerService,
  currency: {
    convert: convertProductCurrency,
  },
});
